import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static override targets = ["content", "copyIcon", "copiedIcon"];
    
    declare contentTarget: HTMLElement;
    declare copyIconTarget: HTMLElement;
    declare copiedIconTarget: HTMLElement;
    
    public async copy() {
        const text = this.contentTarget.textContent?.trim() || "";
        await navigator.clipboard.writeText(text);
        
        // Show copied feedback
        this.copyIconTarget.classList.add("hidden");
        this.copiedIconTarget.classList.remove("hidden");
        
        setTimeout(() => {
            this.copyIconTarget.classList.remove("hidden");
            this.copiedIconTarget.classList.add("hidden");
        }, 2000);
    }
}
